import Axios from '@/api/http'

/**
 * 获取 AI 机器人详情
 * */
export function getairobotbyid(date) {
  return Axios({
    method: 'post',
    url: '/api/getairobotbyid',
    data: date
  })
}

/**
 * 获取分组
 * */
export function getaigrouplist(date) {
  return Axios({
    method: 'post',
    url: '/api/getaigrouplist',
    data: date
  })
}


/**
 * 获取分组详情
 * */
export function getaigroupbyid(date) {
  return Axios({
    method: 'post',
    url: '/api/getaigroupbyid',
    data: date
  })
}


/**
 * cottonbot 执行任务
 * */
export function crewbotworkflow(date) {
  return Axios({
    method: 'post',
    url: '/api/crewbotworkflow',
    data: date,
    useJson: true
  })
}

/**
 * cottonbot 查看任务
 * */
export function getcrewbotworkflow(date) {
  return Axios({
    method: 'post',
    url: '/api/getcrewbotworkflow',
    data: date
  })
}

/**
 * 新增/更新用户添加的智能体
 * */
export function addaiuserrobot(date) {
  return Axios({
    method: 'post',
    url: '/api/addaiuserrobot',
    data: date
  })
}

/**
 * 获取用户智能体列表
 * */
export function getaiuserrobotlist(date) {
  return Axios({
    method: 'post',
    url: '/api/getaiuserrobotlist',
    data: date
  })
}

/**
 * 更新用户机器人
 * */
export function updateaiuserrobot(date) {
  return Axios({
    method: 'post',
    url: '/api/updateaiuserrobot',
    data: date
  })
}


/**
 * 获取用户模型个人描述列表
 * */
export function getaiusermodellist(date) {
  return Axios({
    method: 'post',
    url: '/api/getaiusermodellist',
    data: date
  })
}

/**
 * 根据 ID 获取用户模型个人描述
 * */
export function getaiusermodelbyid(date) {
  return Axios({
    method: 'post',
    url: '/api/getaiusermodelbyid',
    data: date
  })
}

/**
 * 新增/更新用户模型描述
 * */
export function addaiusermodel(date) {
  return Axios({
    method: 'post',
    url: '/api/addaiusermodel',
    data: date
  })
}

/**
 * 删除用户模型个人描述
 * */
export function deleteaiusermodel(date) {
  return Axios({
    method: 'post',
    url: '/api/deleteaiusermodel',
    data: date
  })
}

/**
 * 更新用户模型个人描述
 * */
export function updateaiusermodel(date) {
  return Axios({
    method: 'post',
    url: '/api/updateaiusermodel',
    data: date
  })
}
